import React from "react";
import DynamicWizard from "../crud/DynamicWizard";
import { courseWizardConfig, studentTransferWizardConfig } from "../../modules";

const DynamicWizardTesting = () => {

  const centralRegionBranches = [
    "AG034", "UP646", "AG032", "AD074", "UP479", "UP694", "DH011",
    "DH010", "JH445", "KR084", "KR036", "UP497", "GP073", "HD411",
    "UP644", "UP486", "UP484", "UP489", "UP481", "UP463", "MR031",
    "UP735", "UP630", "UP632", "UT621", "SP028", "UP723", "UP617",
    "UP739"
  ]

  const eastRegionBranches = [
    "OR662", "OR663", "BR671", "OR473", "OR474", "CG692", "OR475", "BR698", "JH674",
    "BR672", "AS677", "AS678", "AS679", "CT564", "JH675",
    "OR740", "AS680", "BR673",
  ]

  const northRegionBranches = [
    "AB443", "AR027", "HR624", "BH024", "BH430", "CH012", "HP491", "HR026", "PB472", "JD029",
    "PB471", "JK687", "JK688", "JK705", "JK785", "HR469", "KA429",
    "KA436", "KR033", "LD022", "NN035", "PA059", "PP025", "PB611",
    "PA060", "RK020", "SA438", "HR495", "JK689", "HR432",
  ]

  const rajasthanRegionBranches = [
    "AJ427", "RJ490", "RJ610", "RJ681", "RJ467", "RJ462", "JR049",
    "JR021", "RJ620", "RJ614", "JP070", "RJ716", "JD075", "KO069",
    "RJ608", "RJ466"
  ]

  const businessAreaDispVals = [
    "RJ696",
    "UP666",
    "DW087",
    "JP001",
    "JP002",
    "DL699",
    "DL487",
    "DL477",
    "DL482",
    "DL738",
    "SE003",
    "SE004",
    "SE606",
    "DL695",
    "FB019",
    "UP789",
    "GN009",
    "UP727",
    "HR686",
    "HR685",
    "HR704",
    "ND008",
    "ND086",
    "DL483",
    "PL037",
    "DL583",
    ...centralRegionBranches,
    ...eastRegionBranches,
    ...northRegionBranches,
    ...rajasthanRegionBranches
  ];


  return (
    <div>
      <DynamicWizard
        config={studentTransferWizardConfig}
        onFinished={() => { }}
        enabledOnList={businessAreaDispVals}
        recordId={90}
        checkPermission={true}
        enabledForAllBUs={true}
      />
    </div>
  );
};

export default DynamicWizardTesting;
